/**
 * GPT Image 2.5 Sunburst（gpt-image-2.5-sunburst）manifest
 * 数据来源：image.json field_map
 * 特点：与 Flare 同档位（图像质量五档 + 背景三档），仅模型 ID 与显示名不同
 */
import type { ImageModelConfig } from '../../types';

export const gptImage2_5Sunburst: ImageModelConfig = {
  id: '01M2Q6TDPH53FXJTWQ1VBMB19V',
  displayName: 'GPT Image 2.5 Sunburst',

  defaults: {
    ratio: '1:1', // 接口 select: true 项
    resolution: '2K', // 接口 resolution.default
    quality: 'medium', // 接口 quality.default
    background: 'auto', // 接口 background.default
  },

  ratioOptions: {
    '*': [
      { label: '智能比例', labelKey: 'canvas.image.config.ratioAuto', value: 'auto' }, // 由模型按内容自动定比例
      { label: '1:1', value: '1:1' },
      { label: '2:3', value: '2:3' },
      { label: '3:2', value: '3:2' },
      { label: '3:4', value: '3:4' },
      { label: '4:3', value: '4:3' },
      { label: '9:16', value: '9:16' },
      { label: '16:9', value: '16:9' },
      { label: '21:9', value: '21:9' },
    ],
  },

  resolutionOptions: [
    { label: '1K', value: '1K' },
    { label: '2K', value: '2K' },
    { label: '4K', value: '4K' },
  ],
  resolutionLabel: '清晰度', // 接口 field_map.resolution.label
  resolutionLabelKey: 'canvas.image.config.resolution',

  qualityOptions: [
    { label: '低画质', labelKey: 'canvas.image.config.qualityLow', value: 'low' },
    { label: '中画质', labelKey: 'canvas.image.config.qualityMedium', value: 'medium' },
    { label: '高画质', labelKey: 'canvas.image.config.qualityHigh', value: 'high' },
    { label: '超高画质', labelKey: 'canvas.image.config.qualityXHigh', value: 'xhigh' },
    { label: '最强画质', labelKey: 'canvas.image.config.qualityMax', value: 'max' },
  ],

  // 背景档位（本模型独占）：auto=自动 / transparent=透明 / opaque=不透明
  backgroundOptions: [
    { label: '自动', labelKey: 'canvas.image.config.bgAuto', value: 'auto' },
    { label: '透明', labelKey: 'canvas.image.config.bgTransparent', value: 'transparent' },
    { label: '不透明', labelKey: 'canvas.image.config.bgOpaque', value: 'opaque' },
  ],

  // 支持 @ 参考图（GPT Image 系列）
  supportAtMention: true,

  toggles: {},

  limits: {
    maxRefImages: 16, // 接口 field_map.ref_images.max
  },

  /** 画布扩展（仅画布用到的字段；feed 不消费） */
  canvas: {
    limits: { promptMaxLength: 8000 },
  },
};
